import React, { useState } from 'react';
import { FiPlus, FiBox } from 'react-icons/fi';
import ProductsSidebar from '../components/ProductsSidebar';
import GenericAddModal from '../components/GenericAddModal';
import useLocalState from '../hooks/useLocalState';
import { sortData } from '../utils/tableUtils';

const initialData = [
  { ref: 'C.R.P._MASK', label: 'C.R.P. MASK', category: 'Face Care', price: '250.00', stock: '0', status: 'On Sale' },
  { ref: 'WOW_CURL_CREAM', label: 'WOW CURL CREAM', category: 'Hair Care', price: '100.00', stock: '0', status: 'On Sale' },
  { ref: 'BOOSTER_SERUM', label: 'BOOSTER SERUM 25', category: 'Face Care', price: '550.00', stock: '0', status: 'On Sale' }
];

export default function ProductCatalog() {
  const [data, setData] = useLocalState('products_catalog', initialData);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: 'ref', direction: 'asc' });

  const handleAdd = (newData) => setData([{ ...newData, stock: '0', status: 'On Sale' }, ...data]);
  const handleSort = (key) => setSortConfig({ key, direction: sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc' });
  const sortedData = sortData(data, sortConfig);

  return (
    <div className="flex h-full font-sans overflow-hidden bg-white">
      <ProductsSidebar />
      <div className="flex-1 flex flex-col bg-[#a6e4e7] p-2">
        <div className="flex justify-between items-center mb-3 px-1">
          <div className="flex items-center space-x-2">
            <FiBox className="text-xl text-teal-800" />
            <span className="font-medium text-[15px] text-teal-700">Products & Services ({data.length})</span>
          </div>
          <button onClick={() => setIsModalOpen(true)} className="bg-[#0000a0] text-white p-1.5 rounded hover:bg-blue-900"><FiPlus /></button>
        </div>
        <div className="flex-1 overflow-x-auto bg-white border border-black">
          <table className="min-w-full border-collapse text-[12px]">
            <thead>
              <tr className="bg-[#a6e4e7] text-teal-900">
                <th onClick={() => handleSort('ref')} className="p-2 border border-black text-left cursor-pointer">Ref.</th>
                <th onClick={() => handleSort('label')} className="p-2 border border-black text-left cursor-pointer">Label</th>
                <th onClick={() => handleSort('category')} className="p-2 border border-black text-left cursor-pointer">Category</th>
                <th onClick={() => handleSort('price')} className="p-2 border border-black text-right cursor-pointer">Selling Price</th>
                <th onClick={() => handleSort('stock')} className="p-2 border border-black text-right cursor-pointer">Physical Stock</th>
                <th className="p-2 border border-black text-center">Status</th>
              </tr>
            </thead>
            <tbody>
              {sortedData.map((row, idx) => (
                <tr key={idx} className="hover:bg-blue-50">
                  <td className="p-2 border border-black font-bold">{row.ref}</td>
                  <td className="p-2 border border-black">{row.label}</td>
                  <td className="p-2 border border-black text-gray-500">{row.category}</td>
                  <td className="p-2 border border-black text-right font-medium">{row.price}</td>
                  <td className="p-2 border border-black text-right">{row.stock}</td>
                  <td className="p-2 border border-black text-center"><span className="bg-green-100 px-2 py-0.5 rounded text-green-800">{row.status}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <GenericAddModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} onAdd={handleAdd} title="Add Product" fields={[
          { name: 'ref', label: 'Reference' }, { name: 'label', label: 'Label' }, { name: 'category', label: 'Category' }, { name: 'price', label: 'Price' }
        ]} />
      </div>
    </div>
  );
}